export default "__VITE_ASSET__62ffe6d8__"